import React from "react";
import Dashboard from "./AppComp/Dashboard";

function App() {
  return (
    <div>
      {/* <h1>Testing</h1> */}

      <Dashboard />
    </div>
  );
}

export default App;
